import React from 'react';
import {
    Spinner
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../../common/Helpers';
import SmartCollectionProductTagsValidationRuleComponent from './SmartCollectionProductTagsValidationRuleComponent';

class SmartCollectionProductTagsValidationRulePage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            rule: null,
            editId: null
        };

        const { params } = this.props.match;

        if (params.id) {
            this.state.editId = params.id
        }
    }

    render() {

        var title = "Create Validate Product Tags In A Smart Collection";
        var actionTitle = "Create";

        if (this.state.editId != null) {
            title = "Update Validate Product Tags In A Smart Collection";
            actionTitle = "Update";
        }

        return (
            <React.Fragment>
                {this.state.loading && <Spinner accessibilityLabel="Loading" size="large" color="teal" />}
                {!this.state.loading && <SmartCollectionProductTagsValidationRuleComponent
                    title={title}
                    actionTitle={actionTitle}
                    rule={this.state.rule}
                    onAction={this.handleSaveOrCreate}
                />}
            </React.Fragment>
        );
    }

    handleSaveOrCreate = (rule) => {

        let body = JSON.stringify({ ...rule });
        let method = "POST";

        if (this.state.editId != null) {
            method = "PUT";
            body = JSON.stringify({
                ...rule,
                id: this.state.editId
            });
        }

        fetch(`api/validationRules/SmartCollectionProductTagsValidation`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: body
        }).then(() => {
            this.props.history.push("/validation-rules");
        });
    }

    componentDidMount() {

        if (this.state.editId != null) {
            fetch(`api/validationRules/SmartCollectionProductTagsValidation/${this.state.editId}`, {
                method: 'get'
            })
                .then(response => response.json())
                .then(data => this.setState({
                    rule: data,
                    loading: false
                }));
        }
        else {
            this.setState({
                loading: false
            })
        }
    }
}

export default SmartCollectionProductTagsValidationRulePage;